import { create } from 'zustand';

/**
 * Global sign-in modal control (multi-wallet).
 *
 * Any "Sign In" / "Connect Wallet" trigger anywhere in the app calls `open()` to
 * surface the single wallet picker (Xaman + Joey) rendered once by DefaultPageLayout,
 * instead of each site hard-wiring the Xaman-only login flow.
 */
interface SignInModalState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useSignInModalStore = create<SignInModalState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
